/* ────────────────────────────────────────────────────────────────
   HS Product Gallery — native vervanging van ProductWiz (juli 2026)
   Gedrag gelijk aan de ProductWiz-swiper:
   - hoofdbeeld horizontaal versleepbaar (muis) / veegbaar (touch)
   - thumbnails klikbaar, actieve thumb gemarkeerd, scrollt mee
   - klik op hoofdbeeld = fullscreen lightbox (pijlen, teller,
     desktop: klik = inzoomen met muis-pan; mobiel: vegen + knijp-zoom)
   - bij variant-wissel (Shopify) wordt de galerij server-side
     opnieuw gerenderd en hier gesynchroniseerd (PUB_SUB variantChange)
   Bestand hoort bij assets/hs-gallery.css
   ──────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  /* ══════════════ Lightbox (één per pagina, on demand) ══════════════ */
  var lightbox = null;

  function buildLightbox() {
    if (lightbox) return lightbox;

    var root = document.createElement('div');
    root.className = 'hs-lb';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Afbeelding vergroot bekijken');
    root.innerHTML =
      '<div class="hs-lb__bar"></div>' +
      '<div class="hs-lb__counter"></div>' +
      '<div class="hs-lb__stage"><div class="hs-lb__track"></div></div>' +
      '<button type="button" class="hs-lb__btn hs-lb__prev" aria-label="Vorige afbeelding">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="hs-lb__btn hs-lb__next" aria-label="Volgende afbeelding">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="hs-lb__btn hs-lb__close" aria-label="Sluiten">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button>' +
      '<div class="hs-lb__dots"></div>';
    document.body.appendChild(root);

    var stage = root.querySelector('.hs-lb__stage');
    var track = root.querySelector('.hs-lb__track');
    var counter = root.querySelector('.hs-lb__counter');
    var dotsWrap = root.querySelector('.hs-lb__dots');

    var state = { items: [], idx: 0, open: false, zoomed: false, scale: 2.4, onClose: null, pinch: null };

    /* de <img> van de nu gecentreerde slide */
    function curImg() {
      var slide = track.children[state.idx];
      return slide ? slide.querySelector('img') : null;
    }

    function buildSlides() {
      track.innerHTML = '';
      state.items.forEach(function (item) {
        var slide = document.createElement('div');
        slide.className = 'hs-lb__slide';
        var im = document.createElement('img');
        im.src = item.src;                         /* al-geladen galerij-resolutie → direct */
        im.alt = item.alt || '';
        im.setAttribute('data-zoom', item.zoom || item.src);
        im.draggable = false;
        slide.appendChild(im);
        track.appendChild(slide);
      });
    }
    function buildDots() {
      dotsWrap.innerHTML = '';
      if (state.items.length < 2) return;
      state.items.forEach(function (_, j) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'hs-lb__dot';
        d.setAttribute('aria-label', 'Afbeelding ' + (j + 1));
        d.addEventListener('click', function () { goTo(j, true); });
        dotsWrap.appendChild(d);
      });
    }
    function syncActive(i) {
      state.idx = i;
      counter.textContent = (i + 1) + ' / ' + state.items.length;
      Array.prototype.forEach.call(dotsWrap.children, function (d, j) {
        d.classList.toggle('is-active', j === i);
      });
    }
    function goTo(i, smooth) {
      i = Math.min(Math.max(i, 0), state.items.length - 1);
      unzoom();
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      syncActive(i);
    }
    function nav(dir) {
      goTo((state.idx + dir + state.items.length) % state.items.length, true);
    }

    /* native swipe: de actieve slide volgt de scrollpositie (zoals het hoofdbeeld) */
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        i = Math.min(Math.max(i, 0), state.items.length - 1);
        if (i !== state.idx) { unzoom(); syncActive(i); }
      });
    });

    /* ── Zoom (werkt op de gecentreerde slide) ── */
    function setOrigin(clientX, clientY) {
      var img = curImg(); if (!img) return;
      var r = img.getBoundingClientRect();
      var x = Math.min(Math.max(((clientX - r.left) / r.width) * 100, 0), 100);
      var y = Math.min(Math.max(((clientY - r.top) / r.height) * 100, 0), 100);
      img.style.transformOrigin = x + '% ' + y + '%';
    }
    function applyScale() { var img = curImg(); if (img) img.style.transform = 'scale(' + state.scale + ')'; }
    /* Wissel de gecentreerde slide naar de scherpe zoom-resolutie, alleen bij inzoomen.
       Het oude frame blijft in beeld tot de hi-res geladen is → geen flikkering. */
    function ensureZoom() {
      var img = curImg(); var item = state.items[state.idx];
      if (img && item && item.zoom && item.zoom !== item.src && img.getAttribute('src') !== item.zoom) {
        img.src = item.zoom;
      }
    }
    function zoomAt(clientX, clientY, scale) {
      state.scale = scale || 2.4;
      ensureZoom();
      setOrigin(clientX, clientY);
      applyScale();
      root.classList.add('is-zoomed');
      track.classList.add('is-zoomed');   /* schakelt de track-scroll uit → 1 vinger pant */
      state.zoomed = true;
    }
    function unzoom() {
      var img = curImg();
      if (img) img.style.transform = '';
      root.classList.remove('is-zoomed');
      track.classList.remove('is-zoomed');
      state.zoomed = false;
      state.scale = 2.4;
    }

    function open(items, idx, onClose) {
      state.items = items;
      state.idx = idx || 0;
      state.open = true;
      state.onClose = onClose || null;
      buildSlides();
      buildDots();
      syncActive(state.idx);
      root.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      /* naar de start-slide springen zodra de track z'n breedte heeft */
      requestAnimationFrame(function () { track.scrollLeft = state.idx * track.clientWidth; });
      root.querySelector('.hs-lb__close').focus();
    }
    function close() {
      root.classList.remove('is-open');
      unzoom();
      state.open = false;
      document.documentElement.style.overflow = '';
      if (state.onClose) state.onClose(state.idx);
    }

    root.querySelector('.hs-lb__close').addEventListener('click', close);
    root.querySelector('.hs-lb__prev').addEventListener('click', function () { nav(-1); });
    root.querySelector('.hs-lb__next').addEventListener('click', function () { nav(1); });

    /* klik: op de foto (desktop-muis) = zoomen; naast de foto = sluiten.
       Op touch doet tikken niets (mobiel zoomt uitsluitend via knijpen). */
    stage.addEventListener('click', function (e) {
      if (e.target.tagName === 'IMG') {
        if (e.pointerType === 'touch') return;
        if (state.zoomed) unzoom();
        else zoomAt(e.clientX, e.clientY);
      } else if (!state.zoomed) {
        close();
      }
    });
    /* muis-pan tijdens zoom: origin volgt de cursor */
    stage.addEventListener('mousemove', function (e) {
      if (state.zoomed) setOrigin(e.clientX, e.clientY);
    });

    /* toetsenbord */
    document.addEventListener('keydown', function (e) {
      if (!state.open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') nav(-1);
      else if (e.key === 'ArrowRight') nav(1);
    });

    /* touch: 1 vinger vegen = native track-scroll (vloeiend). Knijpen met twee
       vingers = traploos zoomen; 1 vinger slepen tijdens zoom = pannen. */
    function pinchDist(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        ensureZoom();
        state.pinch = { d0: pinchDist(e.touches), s0: state.zoomed ? state.scale : 1 };
      }
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (state.pinch && e.touches.length === 2) {
        e.preventDefault();
        var s = state.pinch.s0 * (pinchDist(e.touches) / state.pinch.d0);
        s = Math.min(Math.max(s, 1), 4);
        var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        state.scale = s;
        setOrigin(midX, midY);
        if (s > 1.02) {
          applyScale();
          root.classList.add('is-zoomed');
          track.classList.add('is-zoomed');
          state.zoomed = true;
        } else {
          var img0 = curImg(); if (img0) img0.style.transform = '';
          root.classList.remove('is-zoomed');
          track.classList.remove('is-zoomed');
          state.zoomed = false;
        }
        return;
      }
      if (state.zoomed && e.touches.length === 1) {
        setOrigin(e.touches[0].clientX, e.touches[0].clientY);
        e.preventDefault();
      }
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      if (state.pinch && e.touches.length < 2) {
        state.pinch = null;
        if (state.scale <= 1.05) unzoom();
      }
    });

    lightbox = { open: open, close: close };
    return lightbox;
  }

  /* ══════════════ Galerij-component ══════════════ */
  var HsGallery = function () { return Reflect.construct(HTMLElement, [], HsGallery); };
  HsGallery.prototype = Object.create(HTMLElement.prototype);
  HsGallery.prototype.constructor = HsGallery;

  HsGallery.prototype.connectedCallback = function () {
    this.init();
  };

  /* init is idempotent: wordt opnieuw aangeroepen na een innerHTML-swap
     (variant-wissel); alle listeners hangen aan de nieuwe knopen. */
  HsGallery.prototype.init = function () {
    var self = this;
    this.track = this.querySelector('.hs-gal__track');
    if (!this.track) return;
    this.slides = Array.prototype.slice.call(this.querySelectorAll('.hs-gal__slide'));
    this.thumbsWrap = this.querySelector('.hs-gal__thumbs');
    this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.hs-gal__thumb'));
    this.dots = Array.prototype.slice.call(this.querySelectorAll('.hs-gal__dot'));
    this.current = 0;
    this.setActive(0);
    this.track.scrollLeft = 0;

    /* thumbnails → slide */
    this.thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { self.goTo(i, true); });
    });

    /* stippen (mobiel) → slide */
    this.dots.forEach(function (btn, i) {
      btn.addEventListener('click', function () { self.goTo(i, true); });
    });

    /* pijlen op het hoofdbeeld: doorklikken met wrap-around */
    var prevBtn = this.querySelector('.hs-gal__arrow--prev');
    var nextBtn = this.querySelector('.hs-gal__arrow--next');
    var count = this.slides.length;
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        self.goTo((self.current - 1 + count) % count, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        self.goTo((self.current + 1) % count, true);
      });
    }

    /* scroll-sync: actieve slide bepalen op basis van scrollpositie */
    var raf = null;
    this.track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        i = Math.min(Math.max(i, 0), self.slides.length - 1);
        if (i !== self.current) self.setActive(i);
      });
    });

    /* muis-slepen op het hoofdbeeld (zoals de swiper).
       De window-listeners worden bij een her-init (variant-wissel)
       eerst opgeruimd, anders stapelen ze zich op. */
    var drag = { active: false, moved: false, startX: 0, startLeft: 0 };
    this._drag = drag;
    if (this._onDragMove) {
      window.removeEventListener('pointermove', this._onDragMove);
      window.removeEventListener('pointerup', this._onDragUp);
    }
    this.track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      drag.active = true;
      drag.moved = false;
      drag.startX = e.clientX;
      drag.startLeft = self.track.scrollLeft;
    });
    this._onDragMove = function (e) {
      if (!drag.active) return;
      var dx = e.clientX - drag.startX;
      if (Math.abs(dx) > 5) {
        drag.moved = true;
        self.track.classList.add('is-dragging');
      }
      if (drag.moved) self.track.scrollLeft = drag.startLeft - dx;
    };
    this._onDragUp = function () {
      if (!drag.active) return;
      drag.active = false;
      if (drag.moved) {
        self.track.classList.remove('is-dragging');
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        self.goTo(Math.min(Math.max(i, 0), self.slides.length - 1), true);
        /* klik direct na slepen niet als zoom-klik behandelen */
        drag.suppressClick = true;
        setTimeout(function () { drag.suppressClick = false; }, 80);
      }
    };
    window.addEventListener('pointermove', this._onDragMove);
    window.addEventListener('pointerup', this._onDragUp);

    /* eerste foto's van de andere varianten voorladen (browsercache),
       zodat een variant-wissel vrijwel direct toont. De JSON wordt
       server-side door de snippet meegegeven; ontbreekt hij (bv. op de
       reviewpagina), dan gebeurt er niets. */
    warmVariantPreviews(this);

    /* klik op hoofdbeeld → lightbox */
    this.slides.forEach(function (slide, i) {
      var image = slide.querySelector('img');
      if (!image) return;
      image.addEventListener('click', function () {
        if (drag.suppressClick) return;
        var items = self.slides.map(function (s) {
          var im = s.querySelector('img');
          return { src: im.currentSrc || im.src, zoom: im.getAttribute('data-zoom') || im.currentSrc || im.src, alt: im.alt };
        });
        buildLightbox().open(items, i, function (endIdx) {
          /* galerij meezetten naar de foto waar de lightbox eindigde */
          if (endIdx !== self.current) self.goTo(endIdx, false);
        });
      });
    });
  };

  HsGallery.prototype.goTo = function (i, smooth) {
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    this.setActive(i);
  };

  HsGallery.prototype.setActive = function (i) {
    this.current = i;
    this.thumbs.forEach(function (t, j) {
      t.classList.toggle('is-active', j === i);
      if (j === i) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    this.dots.forEach(function (d, j) {
      d.classList.toggle('is-active', j === i);
      if (j === i) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    /* actieve thumb in beeld houden */
    var active = this.thumbs[i];
    if (active && this.thumbsWrap) {
      var left = active.offsetLeft;
      var right = left + active.offsetWidth;
      var viewL = this.thumbsWrap.scrollLeft;
      var viewR = viewL + this.thumbsWrap.clientWidth;
      if (left < viewL || right > viewR) {
        this.thumbsWrap.scrollTo({ left: left - 10, behavior: 'smooth' });
      }
    }
  };

  if (!customElements.get('hs-gallery')) {
    customElements.define('hs-gallery', HsGallery);
  }

  /* ── Voorladen van variant-hoofdfoto's (idle, eenmalig) ── */
  function warmVariantPreviews(root) {
    var node = root.querySelector('script[data-hs-gal-previews]');
    if (!node || node.__hsWarmed) return;
    node.__hsWarmed = true;
    var list;
    try { list = JSON.parse(node.textContent); } catch (e) { return; }
    if (!list || !list.length) return;
    var liveImg = root.querySelector('.hs-gal__slide img');
    var sizes = liveImg ? liveImg.getAttribute('sizes') : null;
    var run = function () {
      list.forEach(function (p) {
        var im = new Image();
        if (sizes) im.sizes = sizes;
        if (p.srcset) im.srcset = p.srcset;
        im.src = p.src;
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 2500);
  }

  /* ══════════════ Shopify: variant-wissel synchroniseren ══════════════
     Dawn publiceert PUB_SUB_EVENTS.variantChange met de server-side
     opnieuw gerenderde sectie-HTML. Wij nemen daaruit onze galerij
     over (innerHTML-swap) en initialiseren opnieuw. Op de reviewpagina
     bestaat subscribe niet en is dit blok inert. */
  function initVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      return; /* geen Shopify-omgeving (bv. reviewpagina) */
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = (event && event.data) || {};
      if (!data.html || !data.sectionId) return;
      var fresh = data.html.querySelector('#HsGallery-' + data.sectionId);
      var live = document.querySelector('#HsGallery-' + data.sectionId);
      if (!fresh || !live || fresh.innerHTML === live.innerHTML) return;

      /* De oude galerij blijft staan tot de nieuwe hoofdfoto geladen is
         (geen wit vlak); plafond 1200 ms zodat prijs en galerij nooit
         lang uit de pas lopen. Token beschermt tegen snel doorklikken. */
      var token = (live.__hsSwapToken = (live.__hsSwapToken || 0) + 1);
      var apply = function () {
        if (live.__hsSwapToken !== token) return;
        live.innerHTML = fresh.innerHTML;
        if (typeof live.init === 'function') live.init();
      };
      var firstImg = fresh.querySelector('.hs-gal__slide img');
      if (!firstImg) { apply(); return; }
      var pre = new Image();
      pre.fetchPriority = 'high';
      var s = firstImg.getAttribute('sizes');
      if (s) pre.sizes = s;
      var ss = firstImg.getAttribute('srcset');
      if (ss) pre.srcset = ss;
      pre.src = firstImg.getAttribute('src');
      if (pre.complete) { apply(); return; }
      var done = false;
      var finish = function () { if (done) return; done = true; apply(); };
      pre.onload = finish;
      pre.onerror = finish;
      setTimeout(finish, 1200);
    });
  }
  if (document.readyState !== 'loading') initVariantSync();
  else document.addEventListener('DOMContentLoaded', initVariantSync);
})();
